import React from 'react';
import styles from './ShowMore.module.scss';
import LinkWithIcon from '../LinkWithIcon/LinkWithIcon';
import IconChevronRight from '../Icons/IconChevronRight';

const ShowMore = ({ text, onClick }) => (
  <div className={styles.showMore}>
    <div className={styles.showMoreBtn} onClick={onClick}>
      <a>
        <LinkWithIcon
          title={text}
          icon={<IconChevronRight/>}
        />
      </a>
    </div>
  </div>
);

ShowMore.defaultProps = {
  type: '',
};

export default ShowMore;
